import { Injectable } from "@angular/core";
import {
  CanActivate,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from "@angular/router";
import { Router } from "@angular/router";
import { AuthService } from "../../providers/auth.service";
import { Users } from "../model/user";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser: Users = this.authService.getUser;
    //console.log(currentUser);

    if (currentUser && currentUser?.accessToken) {
      if(currentUser.userType == 'MULTI_STORE_MANAGER' ){
        const url = state.url;
        if ( url == "/dashboardv2") {
          this.router.navigate(["/user-management/users"]);
          return false
        }
      }
      // logged in so return true
      return true;
    }

    else if (currentUser && currentUser?.mfaRequired) {
      this.router.navigate(["/auth/mfa"]);
    }

    // not logged in so redirect to login page with the return url
    //console.log(state.url);
    if (state.url == "/dashboard") {
      this.router.navigate(["/auth/login"]);
    } else {
      // Preserve hash fragment (e.g. #ippBlinkHandoff=...) when AuthGuard redirects.
      const hash =typeof window !== "undefined" && window.location.hash? window.location.hash: "";
      const returnUrl = `${state.url}${hash}`;
      this.router.navigate(["/auth/login"], {
        queryParams: { returnUrl },
      });
    }

    return false;
  }
}
